<template>
  <div v-if="attribute_values && attribute_values.length > 0" class="tab-integration">
    <div v-for="(item, i) in attribute_values" :key="i" class="tab-integration__row">
      <div class="tab-integration__row-title">{{ item._embedded.attribute.title }}</div>

      <div v-if="item._embedded.attribute.type === 'html'" class="text text-html" v-html="item.value"></div>

      <div v-else-if="item._embedded.attribute.type === 'url'" class="tab-integration__link">
        <vbutton size="small" :text="$tr('common.go-to-link')" @click="goto(item.value)" />
      </div>

      <div v-else class="text">
        {{ item.value }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'TabIntegration',

  computed: {
    ...mapState('integrations', ['attribute_values'])
  },

  methods: {
    goto(link) {
      window.open(link, '_blank').focus();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.tab-integration {
  &__link {
    margin-left: 8px;
  }

  &__row {
    @include mixin-text-main;
    font-size: 16px;
    margin: 28px 0;
    display: flex;

    .text {
      line-height: 1.6;
    }
  }

  &__row-title {
    width: 200px;
    font-weight: bold;
  }
}
</style>
